import React from 'react';
import { ThemeProvider } from '@emotion/react';
import type { SearchWidgetPageContent } from '@silvertours/common-landingpages-view';
import { AffiliateSearchForm } from '@silvertours/front-features';
import { Theme } from '@silvertours/front-shared';
import { useAffiliateColors } from './content';

const AffiliatePage = ({ color, showPoweredBy }: SearchWidgetPageContent) => {
  const affiliateColors = useAffiliateColors(color);
  const theme = {
    ...Theme.defaultTheme,
    colors: {
      ...Theme.defaultTheme.colors,
      brand: {
        ...Theme.defaultTheme.colors.brand,
        ...affiliateColors,
      },
    },
  };

  return (
    <ThemeProvider theme={theme}>
      <AffiliateSearchForm color={color} showPoweredBy={showPoweredBy} />
    </ThemeProvider>
  );
};

export { AffiliatePage };
